<template>
  <div class="protocol-container">
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%">
      <el-table-column
        label="协议名称"
        prop="name">
      </el-table-column>
      <el-table-column
        :formatter="formatTime"
        label="更新时间"
        prop="updateDate">
      </el-table-column>
      <el-table-column
        :formatter="formatTime"
        label="创建时间"
        prop="createDate">
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as moment from 'moment'
import { getAgreementList } from '@/api/site'

export default {
  name: 'Protocols',
  data() {
    return {
      list: [],
      listLoading: true,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      getAgreementList().then(response => {
        const data = response.data
        this.list = data.agreements
        this.listLoading = false
      })
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.$router.push({ name: 'ProtocolEdit', params: { id: row.id }})
    },
    formatTime: function(row, column) {
      const value = row[column.property];
      return value && moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .protocol-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }

    /* dialog modal start */
    .el-dialog {
      width: 540px;
      .el-form-item {
        .el-input {
          width: 300px;
        }
      }
    }
    /* dialog modal end*/
  }
</style>
